import {EnvironmentConfigData} from '@app/services/config/model/environment-config-data';
import {DeploymentConfigData} from '@app/services/config/model/deployment-config-data';
import { Users } from '@app/constants/users';


export class AppConfigService {

  static environmentConfigData: EnvironmentConfigData = {};
  static deploymentConfigData: DeploymentConfigData = {};


  static initEnvironmentConfigData(environmentConfig: EnvironmentConfigData): void {
    AppConfigService.environmentConfigData = {
      defaultUser: Users.defaultUser,
      ...environmentConfig
    };
  }

  static initDeployment(deploymentConfigData: DeploymentConfigData): void {
    AppConfigService.deploymentConfigData = {
      ...deploymentConfigData
    };
  }
}
